import {
  getIsRROrCRRWithoutCollectivePools,
  getMembershipIntegrationStatus,
  isOrganizableConferenceLocation,
  useOrganizer
} from 'components/event_type_edit'

import { filterEnabledMemberships } from '../../../helpers'

const enrichLocationConfiguration = (config, member) => {
  if (!config) return null

  const integrationError = isOrganizableConferenceLocation(config.kind) && getMembershipIntegrationStatus(member, config.kind)

  return {
    ...config,
    ...(config.kind && { integrationError })
  }
}

export const useLocationConfigurations = ({
  eventType,
  isRoundRobin,
  isCollectiveRoundRobin,
  userPools,
  memberships,
  locationConfigurations
}) => {
  const isRoundRobinLayout = getIsRROrCRRWithoutCollectivePools(
    isRoundRobin,
    isCollectiveRoundRobin,
    userPools
  )

  const enabledMemberships = filterEnabledMemberships(memberships)
  const firstLocation = locationConfigurations?.[0] || {}
  const organizerResult = useOrganizer(eventType, firstLocation.kind, locationConfigurations)
  const currentOrganizer = organizerResult?.currentOrganizer || eventType

  if (isRoundRobinLayout) {
    return enabledMemberships.reduce((acc, member) => ({
      ...acc,
      [member.id]: [enrichLocationConfiguration(member.locationConfiguration, member)].filter(Boolean)
    }), {})
  }

  return {
    [currentOrganizer.id]: (locationConfigurations || [])
      .filter(({ _destroy }) => !_destroy)
      .map((config) => enrichLocationConfiguration(config, currentOrganizer))
      .filter(Boolean)
  }
}
